import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-code': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M149.9 349.1c3.5 3.3 3.7 8.9 0.4 12.4l-17.4 18.6c-1.6 1.8-4 2.8-6.4 2.8-2.2 0-4.4-0.9-6-2.4l-57.7-54.1c-3.7-3.4-3.7-9.3 0-12.8l57.7-54.1c3.4-3.3 9-3.2 12.4 0.4l17.4 18.6 0.2 0.2c3.2 3.6 2.8 9.2-0.8 12.4l-32.8 28.9 32.8 28.9zM369.9 97.9c9 9 14.1 21.3 14.1 34v332.1c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48.1h204.1c12.7 0 24.9 5.1 33.9 14.1zM256 51.9v76.1h76.1zM336 464v-288h-104c-13.3 0-24-10.7-24-24v-104h-160v416h288zM209.6 214l24.4 7c4.7 1.3 7.4 6.2 6 10.9l-54.7 188.2c-1.3 4.6-6.2 7.4-10.9 6l-24.4-7.1c-4.7-1.3-7.4-6.2-6-10.9l54.7-188.1c1.4-4.7 6.2-7.4 10.9-6zM234.1 290.9c-3.5-3.3-3.7-8.9-0.4-12.4l17.4-18.6c3.3-3.6 8.9-3.7 12.4-0.4l57.7 54.1c3.7 3.4 3.7 9.3 0 12.8l-57.7 54.1c-3.5 3.3-9.1 3.1-12.4-0.4l-17.4-18.6-0.2-0.2c-3.2-3.6-2.8-9.2 0.8-12.4l32.8-28.9-32.8-28.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-code.js
// module id = 1731
// module chunks = 0